<div class="header-bar">
  <div class="header-left">
    <div class="header-text">New Flow Test</div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button mat-button color="plain" (click)="cancel()">Cancel</button>
    <button mat-button color="lightGreen" (click)="submit()" [disabled]="!selectedFlow || isSubmitting">
      {{ isSubmitting ? 'Queuing…' : 'Queue Test' }}
    </button>
  </div>
</div>

<div class="flow-test-create">
  <div class="container">
    <div class="container-content">
      <div class="field">
        <label>Select Flow</label>
        <mat-form-field appearance="outline" *ngIf="!isLoadingFlows; else loadingFlowsTpl">
          <mat-select
            [value]="selectedFlow"
            (selectionChange)="onFlowChange($event.value)"
            placeholder="Choose a flow to test"
          >
            <mat-option *ngFor="let flow of flows" [value]="flow">
              {{ flow.name }}
              <span class="trigger-badge" *ngIf="flow.entry_event_type_name">
                ({{ flow.entry_event_type_name }})
              </span>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="trigger-form-wrapper" *ngIf="selectedFlow">
        <h3>
          Test Config
          <small *ngIf="selectedFlow.entry_event_type_name">
            – {{ selectedFlow.entry_event_type_name }} trigger
          </small>
        </h3>
        <ng-container #triggerHost></ng-container>
      </div>

      <div class="error" *ngIf="errorMessage">{{ errorMessage }}</div>
    </div>
  </div>
</div>

<ng-template #loadingFlowsTpl>
  <div class="loading">Loading flows…</div>
</ng-template>
